<template>
  <div class="box" ref="box">
    <div class="top">
        <div class="title">
            专区<span>须知</span>
            <img src="./images/zizhutuiguang.png">
        </div>
        <div class="conent">
            <p v-for="(item,index) in copywriter" :key="index">{{index + 1}}. {{item}}</p>
        </div>
    </div>
    <div class="dynamic_title">全部动态</div>
    <div class="dynamic_list">
      <HeatedDiscussion3 />
    </div>
    <div class="btn" @click=goRouter() >
        +发帖
    </div>
    <img @click="goDDconversation" class="callXXQ" src="./images/call.png">
    <div style="width:100%;height:45px;">
    </div>
  </div>
</template>

<script>
import HeatedDiscussion3 from '../../../components/HeatedDiscussion3.vue'
import { get as getUser } from '../../../utils/token'
import { getMenuList } from '../../../../src/api/api'
import { openSingleChat } from '../../../utils/utils'
export default {
  components: {
    HeatedDiscussion3
  },
  data () {
    return {
      HRtext: {},
      user: getUser('user'),
      copywriter: []
    }
  },
  mounted () {
    // const _this = this
    // dd.device.base.getPhoneInfo({
    //   onSuccess: function (data) {
    //     // alert('现在是手机移动端')
    //     _this.isPc = false
    //   },
    //   onFail: function (err) {
    //     alert(JSON.stringify(err))
    //   }
    // })
    if (!this.$route.query.copywriter) {
      this.getList()
    } else {
      this.copywriter = this.$route.query.copywriter.split('|')
    }
    this.$API.upUvData({
      user: this.user.id,
      path: '/exerland/overseasDetail',
      location: 'HR知乎',
      tracking_type: 6
    })
  },
  methods: {
    goDDconversation () {
      openSingleChat({
        name: '星小圈',
        userId: 13122906813
      })
    },
    goRouter () {
      // this.$router.push(`/exerland${path}/create`)
      this.$router.replace({
        name: 'Create',
        query: {
          visible_range: 'oversea'
        }
      })
    },
    async getList () {
      const res = await getMenuList(this.user.username)
      this.HRtext = res[0]
      this.copywriter = this.$route.query.copywriter ? this.$route.query.copywriter.split('|') : this.HRtext.copywriter
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
    background-color: #F5F5F5;
    height: 100vh;
    overflow-y: scroll;
    .callXXQ {
      display: inline-block;
      width: 64px;
      position: absolute;
      z-index: 9;
      bottom: 80px;
      right: 10px;
    }
    .btn {
        position: absolute;
        bottom: 0;
        color: #fff;
        width: 100%;
        height: 45px;
        line-height: 45px;
        text-align: center;
        background: #0A93E3;
        border-radius: 15px 15px 0px 0px;
        font-size: 16px;
        font-weight: 600;
    }
    .dynamic_title {
        height: 17.5px;
        font-size: 18px;
        font-weight: 600;
        color: #000000;
        margin: 15px 0 19.5px 17px;
    }
    .top {
        box-sizing: border-box;
        width: 100%;
        background-color: #F3FAFE;
        border-radius: 10px;
        padding: 10px 23px 10px 19px;
        .conent {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            margin-top: 10px;
            & p:not(:last-child) {
                margin-bottom: 10px;
            }
        }
        .title {
            display: flex;
            align-items: center;
            height: 20px;
            // line-height: 20px;
            font-weight: 600;
            font-size: 16px;
            color: #333333;
            span {
                color: #0A93E3;
            }
            img {
                margin-left: 5px;
                width: 16px;
                height: 15.5px;
            }
        }
    }
}
</style>
